import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { PASSWORD_RULES } from '../passwordPolicy';

// Live checklist shown under the password field. A tick icon plus the word "met"/"not met"
// (screen readers) carry the state, so it never relies on colour alone.
const PasswordRequirements: React.FC<{ password: string; id: string }> = ({ password, id }) => {
  const { palette } = useTheme();
  const t = palette.tokens;
  return (
    <Box component="ul" id={id} aria-label="Password requirements" sx={{ listStyle: 'none', m: 0, p: 0, mb: 2.5, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {PASSWORD_RULES.map(rule => {
        const met = rule.test(password);
        const Icon = met ? CheckCircleIcon : RadioButtonUncheckedIcon;
        return (
          <Box component="li" key={rule.id} sx={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Icon aria-hidden sx={{ fontSize: 16, color: met ? t.success : t.mutedSoft }} />
            <Typography sx={{ fontSize: '12.5px', color: met ? t.ink : t.muted }}>
              {rule.label}
              <Box component="span" sx={{ position: 'absolute', width: '1px', height: '1px', p: 0, m: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: 0 }}>{met ? ' (met)' : ' (not met)'}</Box>
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PasswordRequirements;
